import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
  selector: 'app-newsletters-type01',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, HeadingSectionType01Component, SlickCarouselModule],
  templateUrl: './newsletters-type01.component.html',
  styleUrl: './newsletters-type01.component.scss'
})
export class NewslettersType01Component implements OnInit {

  public view: any = {
  }

  constructor(public _tfmService : TFMService, private route: ActivatedRoute) {

  }

  ngOnInit(): void {
      this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        // this._tfmService.log(this.view);

      });
  }

}
